<template>
  <div class="auth-container">
    <div class="auth-card">
      <!-- 左侧装饰图片区域 - PC端显示 -->
      <div class="auth-left" aria-hidden="true">
        <img src="/static/images/login-image-3.png" class="decor-img third-img" alt="" />
        <img src="/static/images/login-image-2.png" class="decor-img second-img" alt="" />
        <img src="/static/images/login-image-1.png" class="decor-img first-img" alt="" />
      </div>

      <!-- 右侧表单区域 -->
      <div class="auth-right">
        <!-- 头部区域 -->
        <div class="auth-header">
          <img src="/static/images/user.png" alt="用户图标" class="user-icon" />
          <div class="header-title">登录</div>
        </div>

        <!-- 分隔线 -->
        <div class="header-divider"></div>

        <!-- 登录表单 -->
        <el-form ref="loginForm" :model="form" :rules="rules" class="auth-form" @submit.native.prevent="handleLogin">
          <div class="form-item">
            <span class="form-label">账号:</span>
            <el-form-item prop="account">
              <el-input v-model="form.account" placeholder="请输入注册手机号" maxlength="11" clearable
                @keyup.enter.native="handleLogin" />
            </el-form-item>
          </div>

          <div class="form-item">
            <span class="form-label">密码:</span>
            <el-form-item prop="pwd">
              <el-input v-model="form.pwd" type="password" placeholder="请输入登录密码" show-password clearable
                @keyup.enter.native="handleLogin" />
            </el-form-item>
          </div>

          <div class="form-links">
            <router-link to="/register" class="link-primary">新用户注册</router-link>
            <router-link to="/reset-password" class="link-secondary">忘记密码?</router-link>
          </div>

          <div class="form-actions">
            <el-button type="primary" class="submit-btn" :loading="loading" @click="handleLogin">
              登录
            </el-button>
          </div>
        </el-form>
      </div>
    </div>

    <!-- 版权信息 -->
    <div class="auth-copyright">
      Copyright &copy; 2023 北京新知堂剑桥少儿英语
    </div>
  </div>
</template>

<script>
import api from '@/utils/api'
import auth from '@/utils/auth'

export default {
  name: 'Login',
  data () {
    return {
      loading: false,
      form: {
        account: '',
        pwd: ''
      },
      rules: {
        account: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        pwd: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度为6-20位', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    /**
     * 登录
     */
    handleLogin () {
      this.$refs.loginForm.validate((valid) => {
        if (!valid) {
          return
        }

        this.loading = true

        // MVC 接口使用 form-urlencoded 格式
        const params = new URLSearchParams()
        params.append('account', this.form.account)
        params.append('pwd', this.form.pwd)

        this.$axios.post(api.login, params, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        }).then(response => {
          const result = response.data.result
          // 后端返回：successful: 0(账号密码错误), 1(账号过期), 2(成功)
          if (result.successful === 2) {
            const token = result.token
            if (token) {
              // 使用统一的 auth 工具保存 Token
              auth.setToken(token)
            }

            this.$message({
              message: '登录成功',
              type: 'success'
            })

            // 获取跳转目标：优先使用 redirect 参数
            const redirect = this.$route.query.redirect
            const targetPath = redirect ? decodeURIComponent(redirect) : '/'

            // 使用 router 跳转
            setTimeout(() => {
              this.$router.push(targetPath)
            }, 500)
          } else if (result.successful === 1) {
            this.$message({
              message: '账号已过期，请联系管理员激活',
              type: 'error'
            })
          } else {
            this.$message({
              message: '账号或密码不正确，请重新输入',
              type: 'error'
            })
          }
        }).catch(function (error) {
          console.error('登录失败:', error)
          this.$message({
            message: error.response && error.response.data && error.response.data.message ? error.response.data.message : '登录失败，请稍后重试',
            type: 'error'
          })
        }.bind(this)).finally(function () {
          this.loading = false
        }.bind(this))
      })
    }
  }
}
</script>

<style scoped>
/* ========================================
   基础样式（移动端优先）
   ======================================== */
.auth-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #00CCFF;
  padding: 15px;
  box-sizing: border-box;
}

.auth-card {
  width: 100%;
  max-width: 400px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  padding: 25px 20px;
  box-sizing: border-box;
}

/* 左侧装饰图片 - 移动端隐藏 */
.auth-left {
  display: none;
}

/* 头部区域 */
.auth-header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 15px;
}

.user-icon {
  width: 50px;
  height: 50px;
  margin-right: 15px;
}

.header-title {
  font-size: 22px;
  font-weight: bold;
  color: #000;
  letter-spacing: 4px;
}

/* 分隔线 */
.header-divider {
  height: 1px;
  background: #cccccc;
  margin-bottom: 20px;
}

/* 表单区域 */
.auth-form {
  width: 100%;
}

.form-item {
  margin-bottom: 20px;
}

.form-item .el-form-item {
  margin-bottom: 0;
}

.form-label {
  display: block;
  font-size: 16px;
  color: #000;
  margin-bottom: 8px;
}

.form-item .el-input {
  height: 44px;
}

.form-item .el-input>>>.el-input__inner {
  height: 44px;
  line-height: 44px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 0 15px;
}

/* 链接区域 */
.form-links {
  text-align: center;
  margin-top: 20px;
  font-size: 14px;
}

.link-primary {
  color: #30adfa;
  text-decoration: none;
  margin-right: 15px;
}

.link-secondary {
  color: #5a5a5a;
  text-decoration: none;
}

.link-primary:hover,
.link-secondary:hover {
  text-decoration: underline;
}

/* 提交按钮 */
.form-actions {
  text-align: center;
  margin-top: 25px;
}

.submit-btn {
  width: 100%;
  max-width: 260px;
  height: 44px;
  font-size: 18px;
  border-radius: 5px;
  background: #30adfa;
  border: none;
}

.submit-btn:hover {
  opacity: 0.9;
}

/* 版权信息 */
.auth-copyright {
  margin-top: 20px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
  text-align: center;
}

/* ========================================
   中等屏幕 (768px - 991px) - 平板
   ======================================== */
@media (min-width: 768px) {
  .auth-container {
    padding: 20px;
  }

  .auth-card {
    display: flex;
    max-width: 90%;
    padding: 0;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  }

  /* 左侧装饰图片 - 显示 */
  .auth-left {
    display: block;
    position: relative;
    width: 35%;
    min-height: 400px;
    overflow: hidden;
    /* background: linear-gradient(135deg, #00b4db 100%, #00b4db 0%); */
  }

  .decor-img {
    position: absolute;
    max-width: 130px;
    height: auto;
  }

  .first-img {
    top: 80px;
    left: 15%;
  }

  .second-img {
    top: 80px;
    left: 55%;
  }

  .third-img {
    top: 80px;
    left: 75%;
  }

  /* 右侧表单区域 */
  .auth-right {
    width: 55%;
    padding: 30px 25px;
    box-sizing: border-box;
  }

  .auth-header {
    justify-content: flex-start;
    padding-bottom: 0;
  }

  .user-icon {
    width: 60px;
    height: 60px;
    margin-right: 20px;
  }

  .header-title {
    font-size: 22px;
    letter-spacing: 8px;
  }

  .header-divider {
    max-width: 356px;
    margin: 20px 0;
  }

  .form-item {
    display: flex;
    align-items: center;
    max-width: 356px;
  }

  .form-label {
    display: inline-block;
    width: 70px;
    font-size: 18px;
    margin-bottom: 0;
    flex-shrink: 0;
  }

  .form-item .el-form-item {
    flex: 1;
  }

  .form-item .el-input {
    flex: 1;
    height: 40px;
  }

  .form-item .el-input>>>.el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  .form-links {
    text-align: left;
    padding-left: 70px;
    font-size: 16px;
  }

  .form-actions {
    text-align: left;
    padding-left: 70px;
    margin-top: 30px;
  }

  .submit-btn {
    width: 200px;
    height: 40px;
  }
}

/* ========================================
   大屏幕 (992px+) - 桌面
   ======================================== */
@media (min-width: 992px) {
  .auth-container {
    padding: 30px;
  }

  .auth-card {
    max-width: 1000px;
    height: 540px;
    margin-top: 60px;
    border-radius: 20px;
  }

  .auth-left {
    width: calc(60% - 20px);
    min-height: 540px;
    border-radius: 20px 0 0 20px;
  }

  .decor-img {
    max-width: none;
  }

  .first-img {
    top: 90px;
    left: 55px;
  }

  .second-img {
    top: 90px;
    left: 200px;
  }

  .third-img {
    top: 90px;
    left: 270px;
  }

  .auth-right {
    width: 40%;
    min-width: 370px;
    padding: 30px 30px 30px 20px;
  }

  .user-icon {
    width: 74px;
    height: 74px;
  }

  .header-title {
    line-height: 74px;
  }

  .header-divider {
    width: 356px;
  }

  .form-item {
    width: 356px;
    margin-top: 30px;
  }

  .form-label {
    width: 90px;
  }

  .form-item .el-input {
    width: calc(100% - 90px);
  }

  .form-links {
    padding-left: 110px;
  }

  .form-actions {
    padding-left: 50px;
    margin-top: 35px;
  }

  .submit-btn {
    width: 260px;
    height: 40px;
    margin-top: 20px;
  }

  .auth-copyright {
    margin-top: 30px;
  }
}

/* ========================================
   超大屏幕 (1200px+)
   ======================================== */
@media (min-width: 1200px) {
  .auth-card {
    margin-top: 80px;
  }
}

/* ========================================
   横屏模式优化（移动设备）
   ======================================== */
@media (max-width: 767px) and (orientation: landscape) {
  .auth-container {
    padding: 10px;
  }

  .auth-card {
    padding: 15px;
  }

  .user-icon {
    width: 40px;
    height: 40px;
    margin-right: 10px;
  }

  .header-title {
    font-size: 18px;
  }

  .form-item {
    margin-bottom: 15px;
  }

  .form-item .el-input {
    height: 40px;
  }

  .form-item .el-input>>>.el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  .submit-btn {
    height: 40px;
    font-size: 16px;
  }

  .auth-copyright {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/auth/Login.vue